<!-- agregar boton crear encuesta -->

<div *ngIf="hayEncuestas && !crearencuesta && !editarEncuesta" class="contenedor-boton">
    <button 
      pButton 
      type="button" 
      icon="pi pi-plus" 
      class="p-button-rounded boton-rosado" 
      pTooltip="Agregar encuesta"
      tooltipPosition="top"
      (click)="onCrearEncuesta()">
    </button>
  </div>
<!-- Si hayEncuestas=false mostrar el componente app-crearencuesta -->
<div *ngIf="(!hayEncuestas || crearencuesta) && !editarEncuesta ">
    <app-crearencuesta (creacionFinalizada)="onCreacionFinalizada()"></app-crearencuesta>
</div>

<div *ngIf="hayEncuestas && !editarEncuesta && !crearencuesta"> 
    <p-table [value]="encuestas" [tableStyle]="{ 'min-width': '50rem' }" [rowHover]="true">
        <ng-template pTemplate="header">
            <tr>
                <th>Nombre</th>
                <th>Descripción</th>
                <th>Activa</th>
                <th>Agregar Encuestados</th>
                <th>Fecha</th>
                <th>Opciones</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-encuesta>
            <tr (click)="navigateToResultados(encuesta._id)" pSelectableRow>
                
                <td>{{ encuesta.Nombre }}</td>
                <td>{{ encuesta.Descripcion }}</td>
                <td>{{ encuesta.Activa ? 'Sí' : 'No' }}</td>
                <td>{{ encuesta.AgregarEncuestados ? 'Sí' : 'No' }}</td>
                <td>{{ encuesta.FechaCrea | date:'short' }}</td>
                <td>
                    <!-- Botón para editar encuesta -->
                    <button pButton pRipple type="button" icon="pi pi-pencil" 
                            class="p-button-rounded p-button-text p-button-warning"
                            pTooltip="Editar Encuesta"
                            (click)="navigateToEncuesta(encuesta._id)">
                    </button>
                    <a 
                    pButton 
                    type="button" 
                    icon="pi pi-external-link" 
                    class="p-button-rounded p-button-text p-button-warning" 
                    pTooltip="Enlace externo"
                    tooltipPosition="top"
                    [href]="'diligenciar/' + encuesta._id"
                    target="_blank">
                    </a>
                </td>

            </tr>
        </ng-template>
    </p-table>
</div>

<div *ngIf="editarEncuesta">
    <app-editarencuesta [IdEncuesta]="idEncuesta" [Encuesta]="Encuesta" (edicionFinalizada)="onEdicionFinalizada()"></app-editarencuesta>
</div>

